export const useBookingStyles = () => {
  return {
    modal: {
        position: 'absolute' as 'absolute',
        top: '40%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '41%',
        height: 'auto',
        minWidth: '40%',
        minHeight: '40%',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: '4',
        borderRadius: '0.5rem',
        padding: '5rem',
        paddingTop: '2rem',
        paddingLeft: '3rem',
        paddingRight: '3rem'
    },
    title: {
        display: 'flex',
        justifyContent: 'center',
        fontWeight: 800,
        fontSize: '1.2rem',
        marginBottom: '3rem'
    },
    content: {
        display: 'flex',
        justifyContent: 'space-evenly'
    },
    bookingBox: {
        borderRadius: '1rem',
        boxShadow: '1px 1px 5px #888888',
        height: '15rem',
        width: '15rem',
        padding: '0.8rem',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
    },
    icon: {
        margin: 'auto 0',
        width: '100%',
        height: '6rem',
        marginBottom: '2rem'
    },
    boxText: {
        fontWeight: 500,
        textAlign: 'center',
        paddingTop: '1rem'
    }
}
}